import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-3" }
const _hoisted_2 = { class: "mb-3" }
const _hoisted_3 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_4 = {
  key: 0,
  class: "ml-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_toolbar, {
        dark: "",
        color: "primary",
        tile: "",
        flat: "",
        class: "mb-5"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, {
            icon: "",
            dark: "",
            onClick: _ctx.close
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createTextVNode("mdi-close", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_v_toolbar_title, null, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createTextVNode("欠席者一覧", -1)
            ]))]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_list, null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chatsAbsence, (absence, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: `${index}-absence`
            }, [
              _createVNode(_component_v_list_item, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, _toDisplayString(absence.child.lastName) + " " + _toDisplayString(absence.child.firstName), 1),
                  _createElementVNode("div", _hoisted_2, "理由：" + _toDisplayString(_ctx.showReason(absence.detail.reason)), 1),
                  (absence.detail.reason === 'others')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(absence.detail.comment), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_v_divider)
            ], 64))
          }), 128))
        ]),
        _: 1
      }),
      (_ctx.chatsAbsence.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, " 欠席者はいません。 "))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}